import React from 'react'
import styles from './styles.module.scss'

function RatingWrapper({ title, children, renderFooter }) {
  return (
    <div role='region' aria-labelledby='rating-title' class={styles.ratingWrapper}>
      <h2 id='rating-title' className={styles.title}>
        {title}
      </h2>
      <div className={styles.body}>{children}</div>
      <footer className={styles.footer}>{renderFooter && renderFooter()}</footer>
    </div>
  )
}

export default RatingWrapper
